import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Store } from '@ngrx/store'
import {  liveQuery } from 'dexie'
import { map } from 'lodash'
import { BehaviorSubject, Observable } from 'rxjs'
import { ONE_MB_IN_BYTES } from '../../constants/FileSize'
import { environment } from '../../../environments/environment'
import { Logout,Login } from '../../core/auth'
import { AppState } from '../../core/reducers'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { ConsultationService, DialogService, DossierService, ParameterService, StateService, TiersService} from '../../services'
import { JSONRpc } from '../../services/service-jsonrpc'
import { db } from '../db'

@Injectable({
	providedIn: 'root'
})
export class NomadeService {

	private called: boolean = false
	constructor(
		private dossierService: DossierService,
		private consultationService: ConsultationService,
		private store: Store<AppState>,
		private router: Router,
		private http: HttpClient,
		private dialogService: DialogService,
        private parameterService: ParameterService,
        private stateService: StateService,
		private tiersService: TiersService
	) {

	}
    menusSaved:BehaviorSubject<any[]> = new BehaviorSubject([]);
    documentTypesSaved:BehaviorSubject<any[]> = new BehaviorSubject([]);
    
	savedDossiers: BehaviorSubject<any[]> = new BehaviorSubject([]);
	savedConsultations: BehaviorSubject<any[]> = new BehaviorSubject([]);
	ready: BehaviorSubject<boolean> = new BehaviorSubject(false)
	loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)

	toSaveDossiers: any[] = []
	toSaveConsultations: any[] = []

    limitFileSize: number;
    currentFileSize: number = 0;
    

	dossiers() {
		return liveQuery(() => db.dossiers.toArray())
	}
	getDossierById(id: number) {
		return liveQuery(() => db.dossiers.where({ id: id }).first())
	}

	getConsultationById(id: number) {
		return liveQuery(() => db.consultations.where({ id: id }).first())
	}

	consultations() {
		return liveQuery(() => db.consultations.toArray())
	}

	requestes() {
		
		return liveQuery(() => db.requestes.toArray());
	}

    async addRequest(request: any): Promise<number | void> {
        const id = await db.addRequest(request);
        return id;
    }

    updateRequest(request,oldRequestId){
        request.ID = oldRequestId;
        db.updateRequest(request)
    }

    deleteRequest(id: number){
        db.deleteRequest(id);
    }
	
	menus() {
		return liveQuery(() => db.menus.toArray())
	}
	addMenu(menu: any) {
		db.addMenu(menu)
	}
	
	addParameter(type:string,value:any) {
			db.addParameter(type,value)
	}
	
	parameters() {
			
			return liveQuery(() => db.parameters.toArray());
	}
	
    addDocumentTypes(types: any){
        db.addDocumentTypes(types)
    }
	documentTypes(){
        return liveQuery(() => db.documentTypes.toArray())
    }
	
	saveAllAndStore() {
		console.log("NomadeService saveAllAndStore",db.isOpen(),this.savedDossiers.value,
		this.menusSaved.value,this.documentTypesSaved.value)
        if (!db.isOpen()) {
        	db.open();
        }	

		this.addParameter("token", environment.tokenauth);
		
	    this.addMenu(this.menusSaved.value);
        this.addDocumentTypes(this.documentTypesSaved.value)
        this.toSaveDossiers=[]; 
		this.savedDossiers.value.forEach(dossier => {
			this.addDossiersFromRelations(dossier.relations);
			if (this.toSaveDossiers.indexOf(dossier.ID) == -1) {
				this.toSaveDossiers.push(dossier.ID)
			}
		})
		console.log("this.toSaveDossiers",this.toSaveDossiers)
         this.toSaveConsultations=[]; 
		this.savedConsultations.value.forEach(consultation => {
			if (this.toSaveConsultations.indexOf(consultation.ID) == -1) {
				this.toSaveConsultations.push(consultation.ID)
			}
		})
		console.log("NomadeService count",db.isOpen(),db.dossiers.count(),db.consultations.count(),db.requestes.count())
		
		db.requestes.where('id').above(-1).delete().then(()=> {
			db.consultations.where('id').above(-1).delete().then(()=>{
				this.consultationService.getListToSave(this.toSaveConsultations).subscribe((response: JSONRpcResponse) => {
					const consultations: any = response.result
					const promises = [];
					consultations.forEach((consultation) => {
						consultation.visites.forEach(visite => {
							this.toSaveDossiers.push(visite.tiers.dossierID)
							const promise = new Promise((resolve, reject) => {
								this.tiersService.relations(visite.tiers.ID).subscribe((response: JSONRpcResponse) => {
									this.addDossiersFromRelations(response.result);
									resolve(response.result);
								}, reject);
							});
							promises.push(promise);
						});
						this.addConsultation(consultation)
					});
					Promise.all(promises).then(() => {
						db.dossiers.where('id').above(-1).delete().then(()=> {
							this.dossierService.getListToSave(this.toSaveDossiers).subscribe((response: JSONRpcResponse) => {
								const dossiers = response.result
								this.limitFileSize = environment.limitTotalFileSize;
								Promise.all(dossiers.map(dossier => this.setBase64DocsDossier(dossier))).then(() => {
									dossiers.forEach(dossier => {
										this.addItem(dossier);
									});
								});
							}, (error) => {
								console.error(error)
							}, () => {
								this.ready.next(true)
								localStorage.setItem('ATYL_MODE_NOMADE', 'true')
								this.store.dispatch(new Logout())
							})
						})
					});
				}, (err) => {
					console.error(err)
				});
			});
		});
		
	}

	addItem(content: any) {
		db.addItem(content)
	}
	addConsultation(content) {
		db.addConsultation(content)
	}
	addMany(content: any[]) {
		db.addMany(content)
	}
	
	updateMenus(menus: any[]) {
		this.menusSaved.next(menus)
	}
    updateDocumentTypes(docTypes: any[]) {
        this.documentTypesSaved.next(docTypes);
    }
	
	updateSavedDossiers(dossiers: any[]) {
		this.savedDossiers.next(dossiers)
	}

	
	
	
	addSavedDossier(dossier: any) {
		const found = this.savedDossiers.value.find(d => d.ID === dossier.ID)
		if (!found) {
			this.savedDossiers.next([...this.savedDossiers.value, dossier])
		}
	}
	removeSavedDossier(dossier: any) {
		let value = this.savedDossiers.value.filter(d => d.ID !== dossier.ID)
		this.savedDossiers.next(value)
	}
	updateSavedConsultations(consultations: any[]) {
		this.savedConsultations.next(consultations)
	}
	addSavedConsultation(consultation: any) {
		const found = this.savedConsultations.value.find(c => c.ID === consultation.ID)
		if (!found) {
			this.savedConsultations.next([...this.savedConsultations.value, consultation])
		}
	}
	removeSavedConsultation(consultation: any) {
		let value = this.savedConsultations.value.filter(c => c.ID !== consultation.ID)
		this.savedConsultations.next(value)
	}
	countSavedDossiers() {
		return this.savedDossiers.value.length
	}
	countSavedConsultations() {
		return this.savedConsultations.value.length
	}

	deactivate() {
		console.log("deactivate before");
		this.dialogService.closeAll()
		this.loading.next(true)
		// get all requestes and execute them
		//let requestes: any[]=this.requestes().getValue();
		
		localStorage.removeItem('ATYL_MODE_NOMADE');
		
		const subscrition=this.requestes().subscribe((requestes: any[]) => {
			const subscrition2 = this.parameters().subscribe((parametres: any[]) => {
			    let token:any;
				parametres.forEach((parametre, index) => {
					if (parametre.type=="token")
						token=parametre.value
				});
				if (token!=undefined &&requestes.length > 0) {					
					environment.tokenauth=token;
					localStorage.setItem('authTokenKey', environment.tokenauth)
					//this.store.dispatch(new Login({ authToken: environment.tokenauth }))
					console.log("nomande Token",environment)
					requestes.forEach((request, index) => {
						setTimeout(() => {
							let rpcMethod = new JSONRpc({
								jsonrpc: '2.0',
								method: request.method,
								params: request.params,
							})
							let response = this.http.post<JSONRpc>(environment.webservice, rpcMethod)
							response.subscribe((res: JSONRpcResponse) => {
								const last: boolean = (requestes.length - 1) == index
								if (last) {
									console.log("deactivate last",last);
									this.__reset__default__()
								}
							})
						}, 1000)
					})
					//this.store.dispatch(new Logout())
					
					
					
				} else {
					console.log("deactivate 0 length",requestes.length);
					this.__reset__default__()
					
				}
			    subscrition.unsubscribe();
				subscrition2.unsubscribe();
			})
		})
		
		
	}

	private __reset__default__() {
		console.log("__reset__default__");
		localStorage.removeItem('ATYL_MODE_NOMADE')
		this.ready.next(false)
		localStorage.removeItem('questionAnswered')
		localStorage.removeItem('securityAnswer')
		localStorage.removeItem('securityQuestion')
		document.documentElement.style.setProperty('--atyl-primary', '#b1ca35')
        document.documentElement.style.setProperty('--atyl-primary-dark', '#679436')
		document.documentElement.style.setProperty('--atyl-accent', '#7bbc3c')
		this.__clear__indexedDb__()
		this.savedDossiers.next([])
		this.savedConsultations.next([])
		this.loading.next(false)
		const subscrition= this.parameterService.getPages().subscribe((pages) => {
            this.stateService.updatePages(pages.result)
            subscrition.unsubscribe();
        })
	  
		
		this.router.navigateByUrl('/login', {
			replaceUrl: false
		})
	}
	 __clear__indexedDb__() {
		console.log("NomadeService __clear__indexedDb__",this.called);
		//if (!this.called) {
			this.called = true
			/*db.dossiers.clear()
			db.consultations.clear()
			db.requestes.clear()*/
			db.dossiers.where('id').above(-1).delete().then(function (deleteCount) {
                console.log( "NomadeService Deleted " + deleteCount + " dossiers");
            });;
			db.consultations.where('id').above(-1).delete().then(function (deleteCount) {
                console.log( "NomadeService Deleted " + deleteCount + " consultations");
            });;
			db.requestes.where('id').above(-1).delete().then(function (deleteCount) {
                console.log( "NomadeService Deleted " + deleteCount + " requestes");
            });;
    		db.menus.where('id').above(-1).delete().then(function (deleteCount) {
                console.log( "NomadeService Deleted " + deleteCount + " menu");
            });;
            db.documentTypes.where('id').above(-1).delete().then(function (deleteCount) {
                console.log( "documentTypes Deleted " + deleteCount + " menu");
            });
    
			
			db.delete().then(() => {
				    console.log("NomadeServiceDatabase successfully deleted");
				}).catch((err) => {
				    console.error("NomadeService Could not delete database");
				}).finally(() => {
				    // Do what should be done next...
				});
			//db.close();	
			
		//}
	}
	parse(data: any) {
		for (const key in data) {
			if (typeof data[key] == 'string') {
				data[key] = JSON.parse(data[key])
			}
		}
		return data
	}

	setBase64DocsDossier(dossier): Promise<any> {
		if (!dossier || !dossier.documents) {
		  return Promise.resolve();
		}
		const promises = dossier.documents.map(doc => {
		  if (!doc || !doc.value || !doc.value.url) {
			return Promise.resolve();
		  }
		  return this.getFileBase64FromUrl(doc.value.url).then(base64 => {
			if (base64) {
			  doc.base64 = base64;
			}
		  });
		});
		return Promise.all(promises);
	}
	  
	getFileBase64FromUrl(url: string): Promise<string> | null {
		if (!url) {
		  return Promise.resolve(null);
		}
		return fetch(url)
		  .then(response => response.blob())
		  .then(blob => {
			const reader = new FileReader();
			reader.readAsDataURL(blob);
			const fileSize = blob.size / ONE_MB_IN_BYTES;
			if (this.currentFileSize + fileSize < this.limitFileSize) {
			  this.currentFileSize += fileSize;
			  return new Promise<string>((resolve) => {
				reader.onload = () => resolve(reader.result as string);
			  });
			} else {
			  console.log("Limite de stockage nomade fichiers dépassée", this.currentFileSize, fileSize, this.limitFileSize, url);
			  return Promise.resolve(null);
			}
		  });
	}
	  
	  

	addDossiersFromRelations(relations){
		if(relations && relations.from && relations.from.length > 0){
			relations.from.forEach(relation => {
				if (this.toSaveDossiers.indexOf(relation.tiers.dossierID) == -1) {
					this.toSaveDossiers.push(relation.tiers.dossierID)
				}
			});
		}
		if(relations && relations.to && relations.to.length > 0){
			relations.to.forEach(relation => {
				if (this.toSaveDossiers.indexOf(relation.tiers.dossierID) == -1) {
					this.toSaveDossiers.push(relation.tiers.dossierID)
				}
			});
		}
		return this.toSaveDossiers;
	}
      
}
